import React from 'react';
import PropTypes from 'prop-types';
import REDUCER_KEY from 'reducers/reducer.keys';
import { Inner } from 'components/Page';
import config from './config';

const RosterVersions = ({ objectId, permissions }) => (
  <Inner
    canAdmin={permissions.CanAdminRosters()
      .hasPermissions()}
    reducer={{
      parent: REDUCER_KEY.roster,
      item: REDUCER_KEY.rosterVersion,
      list: REDUCER_KEY.rosterVersions
    }}
    config={{
      ...config,
      list: {
        ...config.list,
        filters: {
          parent_roster: [objectId]
        }
      },
      detail: {
        ...config.detail,
        parent: {
          parent_roster_id: objectId
        }
      }
    }}
    defaultSize="130px"
    defaultKey="1"
  />
);

RosterVersions.propTypes = {
  objectId: PropTypes.number,
  permissions: PropTypes.object.isRequired
};

RosterVersions.defaultProps = {
  objectId: null
};

export default RosterVersions;
